import React from 'react';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="relative bg-brand-cream overflow-hidden py-16 md:py-24 lg:py-32" data-id="element-51">
      {/* Subtle background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none opacity-30" data-id="element-52">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-brand-sage blur-3xl" data-id="element-53" />
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-brand-rose blur-3xl" data-id="element-54" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10 max-w-6xl" data-id="element-55">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-56">
          {/* Text Content */}
          <div className="flex flex-col items-center text-center lg:items-start lg:text-left order-2 lg:order-1" data-id="element-57">
            <div className="inline-flex items-center justify-center px-4 py-1.5 mb-6 rounded-full bg-brand-rose/50 border border-brand-rose text-brand-navy text-sm font-medium tracking-wide" data-id="element-58">
              For Grandmothers Who Refuse to Give Up
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-59">
              The Bridge Back to Your Grandchildren Starts With One Quiet Step
            </h1>

            <p className="text-lg md:text-xl text-brand-body mb-8 max-w-2xl leading-relaxed" data-id="element-60">
              A gentle, proven framework to rebuild trust with your adult
              children — without begging, fighting, or losing your dignity.
            </p>

            <div className="flex flex-col items-center lg:items-start w-full sm:w-auto" data-id="element-61">
              <Button href="#offer-section" className="w-full sm:w-auto px-10" data-id="element-62">
                Get Instant Access — $27
              </Button>
              <p className="mt-4 text-sm text-brand-body/80 flex items-center gap-2" data-id="element-63">
                <span className="w-1.5 h-1.5 rounded-full bg-brand-gold" data-id="element-64"></span>
                Instant digital download • Start tonight
              </p>
            </div>
          </div>

          {/* Image */}
          <div className="order-1 lg:order-2 flex justify-center lg:justify-end" data-id="element-65">
            <div className="relative w-full max-w-md lg:max-w-lg" data-id="element-66">
              {/* Decorative frame behind image */}
              <div className="absolute inset-0 bg-brand-sage rounded-2xl transform rotate-3 scale-105 -z-10 shadow-sm" data-id="element-67"></div>
              <img src="https://cdn.magicpatterns.com/uploads/fK9CwtgByLJafpr7ARVncv/nano1.png" alt="The Reconciliation Roadmap Bundle on multiple devices" className="w-full h-auto rounded-xl shadow-lg object-cover" data-id="element-68" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}